import { curry, debounce } from 'lib/util'

/**
 * Debounce event handler.
 *
 * Executes `eventHandler` after a `delay` time has passed. If the function is
 * executed again before `delay` expires, the timer is restarted.
 *
 * @param {function} eventHandler         the function to call after the `delay` time expires
 * @param {number} delay                  the number of milliseconds to wait before
 *                                        `eventHandler` is executed, if the function isn't
 *                                        called again
 * @returns {Gaia.AppModule.EventHandler}
 */
export default (eventHandler, delay) => curry((module, component) => {
  let action
  return async (event) => {
    action = action || debounce(async e => eventHandler(module, component, e), delay)
    action(event)
  }
})
